import { render } from "./SoldVsBackordersPage.vue?vue&type=template&id=1cfb7f9b&ts=true"
import script from "./SoldVsBackordersPage.vue?vue&type=script&lang=ts"
export * from "./SoldVsBackordersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__